// import store from '../store';
import { json2xml } from 'xml-js'

export default class Category {
  constructor(api) {
    this.api = api
  }

  create(catList, catDict, mCategories) {
    const xml = this._parseToXml(catList, mCategories)
    console.log('Category.create:', xml)
    return this.api.call_busy({
      '_class': 'Category',
      '_method': 'create',
      'xml': xml,
    }).then(res => {
      if (res.category_list && res.category_list.category && res.category_list.category.length) {
        const resCatList = Array.isArray(res.category_list.category)? res.category_list.category : [res.category_list.category]
        const newArray = resCatList.map(c => {
          const _name = (c._text? c._text.trim() : ('[Undefined categoty name with ID]:' + c._attributes.id))
          return c._attributes.desc?
            {id: c._attributes.id, name: _name, desc: c._attributes.desc.trim()} :
            {id: c._attributes.id, name: _name}
          }
        )
        // catList.children.splice(0, catList.children.length)
        catList.children = newArray
        catList.children.forEach(child => {
          catDict[child.id] = { catId: catList.id, name: child.name }
        });
        return resCatList
      }
      console.log('Category.create - res:', res)
    })
  }

  _parseToXml(catList, mCategories) {
    let jsonObject = {
      request: {
        category_list: {
          _attributes:{
            id: catList.id,
            multiple: catList.multiple
          },
          category: [],
        }
      }
    }
    jsonObject.request.category_list.category = mCategories.map(m => ({
      _attributes: { desc: this.escapeXml(m.desc)},
      _text: this.escapeXml(m.name),
    }))
    return json2xml(jsonObject, {compact: true})
  }

  escapeXml(unsafe) {
    return unsafe.replace(/[<>&'"]/g, function (c) {
      switch (c) {
        case '<': return '&lt;';
        case '>': return '&gt;';
        case '&': return '&amp;';
        case '\'': return '&apos;';
        case '"': return '&quot;';
      }
    });
  }

}